import template from './checks.html';
import controller from './checks.controller';
import './checks.styl';

let checksComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default checksComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/checks/checks.component.js
 **/